import React from 'react';

export const MagnifierIcon = () => {
    return (
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="4" stroke="#BFBFBF" strokeWidth="2" strokeLinejoin="round" />
            <path d="M12.5 11.5L8 7" stroke="#BFBFBF" strokeWidth="2" />
        </svg>
    );
};
